var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['none-wrapper', _vm.fullScreen ? '' : 'non-stretch']},_vm._l((_vm.messages),function(message){return _c('resize-message',{staticClass:"none-message",attrs:{"stickyHeight":_vm.stickyHeight,"messageHeight":100 / _vm.messages.length,"message":message,"pageMessageCount":_vm.messages.length}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }